/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedSubscription<InputType, OutputType> = string & {
  __generatedSubscriptionInput: InputType;
  __generatedSubscriptionOutput: OutputType;
};

export const onUpdateActiveMissionByVin = /* GraphQL */ `subscription OnUpdateActiveMissionByVin($vin: String!) {
  onUpdateActiveMissionByVin(vin: $vin) {
    fleetId
    payload {
      ... on MissionUnassigned {
        fleetId
        timestamp
        version
        vin
      }
      ... on MissionV2 {
        actualArrivalTime
        actualStartTime
        description
        events {
          createdAt
          lastRepeatedAt
          position {
            altitude
            heading
            latitude
            longitude
          }
          repeatCount
          type
        }
        fleetId
        id
        name
        plannedArrivalTime
        progressDetails {
          error {
            raisedAt
            type
          }
          ttl
          value {
            eta
            remainingDistanceInMeters
            traveledDistanceInMeters
            updatedAt
          }
        }
        route {
          createdAt
          durationInSeconds
          externalRouteId
          landingHub {
            active
            address
            createdAt
            id
            name
            position {
              latitude
              longitude
            }
            updatedAt
          }
          launchHub {
            active
            address
            createdAt
            id
            name
            position {
              latitude
              longitude
            }
            updatedAt
          }
          positions {
            altitude
            heading
            latitude
            longitude
          }
          predefinedRouteId
          totalDistanceInMeters
          updatedAt
        }
        state {
          error {
            raisedAt
            type
          }
          ttl
          value {
            state
            updatedAt
          }
        }
        timestamp
        version
        vin
      }
    }
    vin
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateActiveMissionByVinSubscriptionVariables,
  APITypes.OnUpdateActiveMissionByVinSubscription
>;
export const onUpdateHub = /* GraphQL */ `subscription OnUpdateHub {
  onUpdateHub {
    active
    address
    createdAt
    id
    name
    position {
      latitude
      longitude
    }
    updatedAt
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateHubSubscriptionVariables,
  APITypes.OnUpdateHubSubscription
>;
export const onUpdateMission = /* GraphQL */ `subscription OnUpdateMission($id: ID!) {
  onUpdateMission(id: $id) {
    actualArrivalTime
    actualStartTime
    createdAt
    description
    events {
      createdAt
      lastRepeatedAt
      position {
        altitude
        heading
        latitude
        longitude
      }
      repeatCount
      type
    }
    fleetId
    id
    name
    plannedArrivalTime
    progressDetails {
      eta
      remainingDistanceInMeters
      traveledDistanceInMeters
      updatedAt
    }
    route {
      createdAt
      durationInSeconds
      externalRouteId
      landingHub {
        active
        address
        createdAt
        id
        name
        position {
          latitude
          longitude
        }
        updatedAt
      }
      launchHub {
        active
        address
        createdAt
        id
        name
        position {
          latitude
          longitude
        }
        updatedAt
      }
      predefinedRouteId
      totalDistanceInMeters
      updatedAt
      waypoints {
        altitude
        heading
        latitude
        longitude
      }
    }
    state {
      updatedAt
      value
    }
    updatedAt
    vin
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateMissionSubscriptionVariables,
  APITypes.OnUpdateMissionSubscription
>;
export const onUpdateMissionV2 = /* GraphQL */ `subscription OnUpdateMissionV2($id: ID!) {
  onUpdateMissionV2(id: $id) {
    actualArrivalTime
    actualStartTime
    description
    events {
      createdAt
      lastRepeatedAt
      position {
        altitude
        heading
        latitude
        longitude
      }
      repeatCount
      type
    }
    fleetId
    id
    name
    plannedArrivalTime
    progressDetails {
      error {
        raisedAt
        type
      }
      ttl
      value {
        eta
        remainingDistanceInMeters
        traveledDistanceInMeters
        updatedAt
      }
    }
    route {
      createdAt
      durationInSeconds
      externalRouteId
      landingHub {
        active
        address
        createdAt
        id
        name
        position {
          latitude
          longitude
        }
        updatedAt
      }
      launchHub {
        active
        address
        createdAt
        id
        name
        position {
          latitude
          longitude
        }
        updatedAt
      }
      positions {
        altitude
        heading
        latitude
        longitude
      }
      predefinedRouteId
      totalDistanceInMeters
      updatedAt
    }
    state {
      error {
        raisedAt
        type
      }
      ttl
      value {
        state
        updatedAt
      }
    }
    timestamp
    version
    vin
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateMissionV2SubscriptionVariables,
  APITypes.OnUpdateMissionV2Subscription
>;
export const onUpdateVehicle = /* GraphQL */ `subscription OnUpdateVehicle {
  onUpdateVehicle {
    activeMissionId
    adsState
    cameras {
      id
      name
    }
    connectivityStatus {
      description
      expectedDisconnect
      latency
      reason
      state
    }
    createdAt
    customerId
    deviations {
      category
      description
      id
      isBlocking
      origin
      relatedDeviations
      resolvedAt
      sentAt
      severity
      state
    }
    driverMode
    drivingState
    externalId
    fleetId
    latestVehicleUpdate
    licensePlate
    mrmState {
      causes {
        deviationId
      }
      error
      mrmExecutionPhase
      mrmType
      startedAt
      triggerBy
      updatedAt
      value
    }
    name
    owners {
      email
      fullName
      id
      phoneNumber
      position
    }
    position {
      altitude
      heading
      latitude
      longitude
    }
    speedInKmh
    speedInMs
    updatedAt
    vin
    weightInKg
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateVehicleSubscriptionVariables,
  APITypes.OnUpdateVehicleSubscription
>;
export const onUpdateVehicleByVINV2 = /* GraphQL */ `subscription OnUpdateVehicleByVINV2($vin: String!) {
  onUpdateVehicleByVINV2(vin: $vin) {
    activeMissionId {
      error {
        raisedAt
        type
      }
      ttl
      value {
        data
        updatedAt
      }
    }
    adsState {
      error {
        raisedAt
        type
      }
      ttl
      value {
        state
        updatedAt
      }
    }
    connectivityStatus {
      error {
        raisedAt
        type
      }
      ttl
      value {
        expectDisconnection
        latency
        state
        updatedAt
      }
    }
    deviations {
      error {
        raisedAt
        type
      }
      ttl
      value {
        deviation {
          category
          description
          id
          isBlocking
          origin
          relatedDeviations
          resolvedAt
          sentAt
          severity
          state
        }
        updatedAt
      }
    }
    driverMode {
      error {
        raisedAt
        type
      }
      ttl
      value {
        mode
        updatedAt
      }
    }
    drivingState {
      error {
        raisedAt
        type
      }
      ttl
      value {
        state
        updatedAt
      }
    }
    fleetId
    latestVehicleUpdate
    licensePlate
    mrmState {
      error {
        raisedAt
        type
      }
      ttl
      value {
        data {
          causes
          executionPhase
          mrmType
          startedAt
          triggerBy
          value
        }
        updatedAt
      }
    }
    name
    owners {
      email
      fullName
      id
      phoneNumber
      position
    }
    position {
      error {
        raisedAt
        type
      }
      ttl
      value {
        position {
          altitude
          heading
          latitude
          longitude
        }
        updatedAt
      }
    }
    speedMs {
      error {
        raisedAt
        type
      }
      ttl
      value {
        speedMs
        updatedAt
      }
    }
    timestamp
    vin
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateVehicleByVINV2SubscriptionVariables,
  APITypes.OnUpdateVehicleByVINV2Subscription
>;
export const onUpdateVehicleByVin = /* GraphQL */ `subscription OnUpdateVehicleByVin($vin: String!) {
  onUpdateVehicleByVin(vin: $vin) {
    activeMissionId
    adsState
    cameras {
      id
      name
    }
    connectivityStatus {
      description
      expectedDisconnect
      latency
      reason
      state
    }
    createdAt
    customerId
    deviations {
      category
      description
      id
      isBlocking
      origin
      relatedDeviations
      resolvedAt
      sentAt
      severity
      state
    }
    driverMode
    drivingState
    externalId
    fleetId
    latestVehicleUpdate
    licensePlate
    mrmState {
      causes {
        deviationId
      }
      error
      mrmExecutionPhase
      mrmType
      startedAt
      triggerBy
      updatedAt
      value
    }
    name
    owners {
      email
      fullName
      id
      phoneNumber
      position
    }
    position {
      altitude
      heading
      latitude
      longitude
    }
    speedInKmh
    speedInMs
    updatedAt
    vin
    weightInKg
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateVehicleByVinSubscriptionVariables,
  APITypes.OnUpdateVehicleByVinSubscription
>;
export const onUpdateVehicleV2 = /* GraphQL */ `subscription OnUpdateVehicleV2 {
  onUpdateVehicleV2 {
    activeMissionId {
      error {
        raisedAt
        type
      }
      ttl
      value {
        data
        updatedAt
      }
    }
    adsState {
      error {
        raisedAt
        type
      }
      ttl
      value {
        state
        updatedAt
      }
    }
    connectivityStatus {
      error {
        raisedAt
        type
      }
      ttl
      value {
        expectDisconnection
        latency
        state
        updatedAt
      }
    }
    deviations {
      error {
        raisedAt
        type
      }
      ttl
      value {
        deviation {
          category
          description
          id
          isBlocking
          origin
          relatedDeviations
          resolvedAt
          sentAt
          severity
          state
        }
        updatedAt
      }
    }
    driverMode {
      error {
        raisedAt
        type
      }
      ttl
      value {
        mode
        updatedAt
      }
    }
    drivingState {
      error {
        raisedAt
        type
      }
      ttl
      value {
        state
        updatedAt
      }
    }
    fleetId
    latestVehicleUpdate
    licensePlate
    mrmState {
      error {
        raisedAt
        type
      }
      ttl
      value {
        data {
          causes
          executionPhase
          mrmType
          startedAt
          triggerBy
          value
        }
        updatedAt
      }
    }
    name
    owners {
      email
      fullName
      id
      phoneNumber
      position
    }
    position {
      error {
        raisedAt
        type
      }
      ttl
      value {
        position {
          altitude
          heading
          latitude
          longitude
        }
        updatedAt
      }
    }
    speedMs {
      error {
        raisedAt
        type
      }
      ttl
      value {
        speedMs
        updatedAt
      }
    }
    timestamp
    vin
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateVehicleV2SubscriptionVariables,
  APITypes.OnUpdateVehicleV2Subscription
>;
export const onUpdateVideoStreamingError = /* GraphQL */ `subscription OnUpdateVideoStreamingError($cameraID: String, $vin: String!) {
  onUpdateVideoStreamingError(cameraID: $cameraID, vin: $vin) {
    cameraID
    errorCode
    errorMessage
    vin
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateVideoStreamingErrorSubscriptionVariables,
  APITypes.OnUpdateVideoStreamingErrorSubscription
>;
